export default __webpack_public_path__ + "static/media/home-events-conference-img-03.9f26970b.jpg";